/*
 * Dashboard
 *
 * This is the first thing users see of our App, at the '/' route
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import NewsCard from '~/components/NewsCard';
import InactivityWarningCard from '~/components/Dashboard/InactivityWarningCard';
import UpcomingAssignmentsCard from '~/components/Dashboard/UpcomingAssignmentsCard';
import UnassignedApplicationsCard from '~/components/Dashboard/UnassignedApplicationsCard';
import UncompletedTurnReportsCard from '~/components/Dashboard/UncompletedTurnReportsCard';
import MissingShiftLeadersCard from '~/components/Dashboard/MissingShiftLeadersCard';
import { DashboardResource } from '~/generated';
import styles from './styles.module.css';

type DashboardProps = {
  publisherId: number;
  dashboardData: DashboardResource;
  missingShiftleadersData: {
    id: number;
    startDate: string;
    endDate: string;
  }[];
};

export const Dashboard = (props: DashboardProps) => (
  <div className={styles.layout}>
    <NewsCard />
    <div className={styles['content-wrapper']}>
      {props.dashboardData.spurUpForParticipation && <InactivityWarningCard />}
      <UpcomingAssignmentsCard
        upcomingAssignments={props.dashboardData.upcomingAssignments || []}
        publisherId={props.publisherId}
      />
      <UnassignedApplicationsCard
        unassignedApplications={
          props.dashboardData.unassignedApplications || []
        }
      />
      {props.dashboardData.pendingTurnReports &&
        props.dashboardData.pendingTurnReports.length > 0 && (
          <UncompletedTurnReportsCard
            pendingTurnReports={props.dashboardData.pendingTurnReports}
          />
        )}
      {props.missingShiftleadersData.length > 0 && (
        <MissingShiftLeadersCard
          missingShiftleaders={props.missingShiftleadersData}
        />
      )}
    </div>
  </div>
);

export default Dashboard;
